import { faList, faTableCells } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@orobix/orobix-fe-components'
import { useTranslation } from 'react-i18next'

import { GRID_MODE, ObservationsBrowserMode } from '../types'
import useStyles from './SwitchViewButtons.styles'

type SwitchViewButtonsProps = {
  value: ObservationsBrowserMode
  onchange: () => void
  disabled?: boolean
}

export const SwitchViewButtons = ({
  value,
  onchange,
  disabled,
}: SwitchViewButtonsProps) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const isGridMode = value === GRID_MODE

  return (
    <>
      <Button
        buttonType="button"
        type="blank-default"
        label={!isGridMode ? t('Switch to grid view') : ''}
        title={!isGridMode ? t('Switch to grid view') : ''}
        hideLabel
        onClick={onchange}
        icon={
          <FontAwesomeIcon
            className={isGridMode ? classes.switchButtonActive : ''}
            icon={faTableCells}
          />
        }
        disabled={isGridMode}
      />
      <Button
        buttonType="button"
        type="blank-default"
        label={isGridMode ? t('Switch to list view') : ''}
        title={isGridMode ? t('Switch to list view') : ''}
        hideLabel
        onClick={onchange}
        icon={
          <FontAwesomeIcon
            className={!isGridMode ? classes.switchButtonActive : ''}
            icon={faList}
          />
        }
        disabled={!isGridMode}
      />
    </>
  )
}
